import { RiArrowGoBackFill } from "react-icons/ri"
import { Link } from "react-router-dom"
import Label from "../../../../components/title/label"
import Input from "../../../../components/input/Input"
import BackButton from "../../../../components/button/BackButton"
import { Navbar } from "../../../../components/navbar/Navbar"
import { useEffect, useState } from "react"
import axios from "axios"
import { E_immatriculation } from "../../../../constants/constant"


function SiegeContribuable() {

    

  const selectedData = localStorage.getItem("selectedDataPriseEnCharge")
  const [contribuableData] = useState(JSON.parse(selectedData ))
  const [siege, setSiege] = useState(null)
  // const [loading, setLoading] = useState(false)
  const [ setError] = useState(null)

  useEffect(() => {
    const fetchSiege = async () => {
      try {
        const response = await axios.get(`${E_immatriculation}/siege/Contribuable/avalide/${contribuableData.id}`)
        
        setSiege(response.data[0])
        setError(null)
      } catch (err) {
        console.error(err)
        setError("Erreur lors du chargement des données")
      }
    }

    fetchSiege()
  }, [contribuableData.id , setError])



  

  if (!siege) return <div className="text-center p-4">Aucune donnée trouvée</div>;


      // Navbar content
  const contentNavbar = (
    <nav className="flex items-center justify-between">
     <div className="text-white ">
      Siege
     </div>
      <BackButton to="/SituationGeographiqueIm"></BackButton>
    </nav>
  );
    
      return(
        <>
            <div className="w-full bg-[#212122] h-screen">
              <Navbar content={contentNavbar} />
              <main className="">     <div >
    
    <div className="flex justify-center">
      <div className="flex flex-col  p-4 w-[620px]">
        <div className="flex justify-between mt-6">
          <Label text="Adresse actuelle (siège)" />
          <Input
            type="text"
            value={siege?.adresse_actuel || ""}
 
          />
        </div>

        <div className="flex justify-between mt-6">
          <Label text="Fokontany" />
          <Input
          
            value={siege?.fokontany || ""}

          />
        </div>

        <div className="flex justify-between mt-6">
          <Label text="Commune" />
          <Input
            type="text"
            value={siege?.commune || ""}

          />
        </div>

        <div className="flex justify-between mt-6">
          <Label text="District" />
          <Input
            type="text"
            value={siege?.district || ""}

          />
        </div>

        <div className="flex justify-between mt-6">
          <Label text="Région" />
          <Input
            type="text"
            value={siege?.region || ""}
          />
        </div>

        <div className="flex justify-between mt-6">
          <Label text="Province" />
          <Input
            type="text"
            value={siege?.province || ""}

          />
        </div>

        <div className="flex justify-between">
         
          <Link
            to="/SituationGeographiqueIm"
            className="border-[2px] text-white mt-6 mb-6 w-40 p-2 border-white rounded hover:bg-black/70 hover:text-white flex flex-row"
          >
            <RiArrowGoBackFill className="text-2xl text-white mr-2" />
            Fermer
          </Link>
        </div>
      </div>
    </div>
  </div></main>
            </div>
        </>
      )
    }

export default SiegeContribuable